import { render, staticRenderFns } from "./ModalTabelaExpandida.vue?vue&type=template&id=a54225b4&scoped=true"
import script from "./ModalTabelaExpandida.vue?vue&type=script&lang=js"
export * from "./ModalTabelaExpandida.vue?vue&type=script&lang=js"
import style0 from "./ModalTabelaExpandida.vue?vue&type=style&index=0&id=a54225b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54225b4",
  null
  
)

export default component.exports